// PGCET MCA Mock 8 — Computer Awareness (questions 31–55)
const pgcetmcaComputerAwareness = [
  {
    id: 31,
    question: "In the classical Waterfall model of the software development life cycle, which phase immediately follows requirements analysis and specification?",
    options: ["A. Coding", "B. Design", "C. Testing", "D. Maintenance"],
    answer: "B"
  },
  {
    id: 32,
    question: "Which software process model delivers the system as a series of working releases, each one adding new functionality to the previous release?",
    options: ["A. Waterfall model", "B. V-model", "C. Incremental model", "D. Big Bang model"],
    answer: "C"
  },
  {
    id: 33,
    question: "In the V-model of software development, acceptance test planning is carried out in parallel with which development phase?",
    options: ["A. Requirements analysis", "B. Detailed (module) design", "C. Coding", "D. Architectural design"],
    answer: "A"
  },
  {
    id: 34,
    question: "A white-box testing criterion that requires every executable statement of a program to run at least once during testing is called",
    options: ["A. Boundary value analysis", "B. Equivalence partitioning", "C. Acceptance testing", "D. Statement coverage"],
    answer: "D"
  },
  {
    id: 35,
    question: "An input field accepts integer ages from 18 to 60 (both inclusive). Using boundary value analysis, which set of test values is the most appropriate?",
    options: ["A. 17, 18, 60, 61", "B. 18, 39, 60", "C. 0, 18, 60, 100", "D. 19, 59"],
    answer: "A"
  },
  {
    id: 36,
    question: "Re-running previously passed test cases after a code modification, to make sure that features which worked earlier have not been broken, is called",
    options: ["A. Smoke testing", "B. Regression testing", "C. Alpha testing", "D. Stress testing"],
    answer: "B"
  },
  {
    id: 37,
    question: "In software design, the degree to which the elements inside a single module are functionally related and work together towards one purpose is called",
    options: ["A. Coupling", "B. Encapsulation", "C. Cohesion", "D. Polymorphism"],
    answer: "C"
  },
  {
    id: 38,
    question: "The COCOMO model proposed by Barry Boehm is used in software engineering for",
    options: [
      "A. Estimating software effort, cost and development time",
      "B. Measuring the cyclomatic complexity of a program",
      "C. Managing versions of source code",
      "D. Tracking defects reported by users"
    ],
    answer: "A"
  },
  {
    id: 39,
    question: "In object-oriented programming, binding data and the methods that operate on it into a single unit, while restricting direct outside access to that data, is known as",
    options: ["A. Inheritance", "B. Polymorphism", "C. Encapsulation", "D. Message passing"],
    answer: "C"
  },
  {
    id: 40,
    question: "Which type of inheritance is NOT supported through classes in Java, although a similar effect can be obtained using interfaces?",
    options: ["A. Single inheritance", "B. Multilevel inheritance", "C. Hierarchical inheritance", "D. Multiple inheritance"],
    answer: "D"
  },
  {
    id: 41,
    question: "In C++, a class that declares at least one pure virtual function, such as virtual void draw() = 0;, is called",
    options: ["A. An abstract class", "B. A friend class", "C. A virtual base class", "D. A template class"],
    answer: "A"
  },
  {
    id: 42,
    question: "In C++, class D is publicly derived from class B. When an object of D is created and later goes out of scope, the order in which the constructors and destructors are called is",
    options: [
      "A. D(), B(), ~B(), ~D()",
      "B. B(), D(), ~D(), ~B()",
      "C. B(), D(), ~B(), ~D()",
      "D. D(), B(), ~D(), ~B()"
    ],
    answer: "B"
  },
  {
    id: 43,
    question: `What is printed by the following Java code?
      String s1 = new String("hi");
      String s2 = new String("hi");
      System.out.print((s1 == s2) + " " + s1.equals(s2));`,
    options: ["A. true true", "B. true false", "C. false false", "D. false true"],
    answer: "D"
  },
  {
    id: 44,
    question: `What is printed by the Java statement System.out.println(10 + 20 + "Java" + 10 + 20); ?`,
    options: ["A. 30Java30", "B. 1020Java1020", "C. 30Java1020", "D. 1020Java30"],
    answer: "C"
  },
  {
    id: 45,
    question: "What is the output of the Python statement print(list(range(10, 0, -3))) ?",
    options: ["A. [10, 7, 4]", "B. [9, 6, 3, 0]", "C. [10, 7, 4, 1, -2]", "D. [10, 7, 4, 1]"],
    answer: "D"
  },
  {
    id: 46,
    question: "What is the output of the Python statement print(7 // 2, -7 // 2, 7 % -3) ?",
    options: ["A. 3 -3 1", "B. 3 -4 -2", "C. 3 -4 1", "D. 3 -3 -2"],
    answer: "B"
  },
  {
    id: 47,
    question: `What is the output of the following Python code?
      s = "COMPUTER"
      print(s[::-2])`,
    options: ["A. RTPO", "B. REUM", "C. CMUE", "D. RETUPMOC"],
    answer: "A"
  },
  {
    id: 48,
    question: `What is the output of the following Python code?
      a = [1, 2, 3]
      b = a
      b.append(4)
      print(len(a))`,
    options: ["A. 3", "B. 7", "C. 4", "D. An error is raised"],
    answer: "C"
  },
  {
    id: 49,
    question: "Which phase of a compiler reads the stream of characters of the source program and groups them into meaningful tokens?",
    options: ["A. Syntax analysis", "B. Semantic analysis", "C. Code generation", "D. Lexical analysis"],
    answer: "D"
  },
  {
    id: 50,
    question: "Type checking, such as reporting an error when an integer is added to an array name, is mainly performed during which phase of a compiler?",
    options: ["A. Semantic analysis", "B. Lexical analysis", "C. Code generation", "D. Linking"],
    answer: "A"
  },
  {
    id: 51,
    question: `How many tokens are there in the C statement printf("x = %d", x); ?`,
    options: ["A. 5", "B. 7", "C. 9", "D. 10"],
    answer: "B"
  },
  {
    id: 52,
    question: "Which file allocation method supports fast direct access to any block of a file but suffers from external fragmentation of disk space?",
    options: ["A. Contiguous allocation", "B. Linked allocation", "C. Indexed allocation", "D. FAT-based chained allocation"],
    answer: "A"
  },
  {
    id: 53,
    question: "In UNIX-like file systems, the structure that stores a file's metadata (owner, permissions, size and pointers to its data blocks) but NOT the file's name is the",
    options: ["A. Superblock", "B. Directory entry", "C. Inode", "D. Boot block"],
    answer: "C"
  },
  {
    id: 54,
    question: "A cloud service that lets developers deploy their applications on a managed runtime without managing the underlying servers or operating system (for example, Google App Engine) belongs to which service model?",
    options: [
      "A. Infrastructure as a Service (IaaS)",
      "B. Platform as a Service (PaaS)",
      "C. Software as a Service (SaaS)",
      "D. Desktop as a Service (DaaS)"
    ],
    answer: "B"
  },
  {
    id: 55,
    question: "Which lightweight publish–subscribe messaging protocol is widely used for communication between Internet of Things (IoT) devices over low-bandwidth networks?",
    options: ["A. FTP", "B. SMTP", "C. SNMP", "D. MQTT"],
    answer: "D"
  }
];

export default pgcetmcaComputerAwareness;
